module.exports = __webpack_public_path__ + "img/loading.652a6a77.gif";